import * as yup from "yup";

export const busquedaPatenteSchema = yup.object({
  patente: yup
    .string()
    .required("La patente es requerida")
    .matches(
      /^(?:[A-Z,a-z]{3}\d{3}|[A-Z,a-z]{2}\d{3}[A-Z,a-z]{2}|\d{3}[A-Z, a-z]{3}|[A-Z, a-z]{1}\d{3}[A-Z,a-z]{3})$/,
      { message: "Formato de dominio incorrecto", excludeEmptyString: true }
    ),
});

export const aprobarDenunciaSchema = yup.object({
  nombre: yup.string().required("Razon social requerida"),
  documento: yup.string().required("Razon social requerida"),
  direccion_titular: yup.string().required("Dirección del titular requerida"),
  direccion_infraccion: yup.string().required("Dirección de la infracción requerida"),
  provincia: yup.string().required("Provincia requerida"),
  localidad: yup.string().required("Localidad requerida"),
  codigo: yup.string().required("Código postal requerido"),
  patente: yup
  .string()
  .required("Patente del vehículo es requerida")
  .matches(
    /^(?:[A-Z,a-z]{3}\d{3}|[A-Z,a-z]{2}\d{3}[A-Z,a-z]{2}|\d{3}[A-Z, a-z]{3}|[A-Z, a-z]{1}\d{3}[A-Z,a-z]{3})$/,
    { message: "Formato de dominio incorrecto", excludeEmptyString: true }
  ),
  marca: yup.string().required("Marca del vehículo requerido"),
  modelo: yup.string().required("Modelo del vehículo postal requerido"),
});
